module.exports = __webpack_public_path__ + "media/images/smiley-a9216f8126be4ba7117e36c7e0257313.png";